import { render, staticRenderFns } from "./SubChallenge.vue?vue&type=template&id=401fa631&"
import script from "./SubChallenge.vue?vue&type=script&lang=js&"
export * from "./SubChallenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports